export default "__VITE_ASSET__DfRqLB9b__"